<template>
  <div class="">
      <div class="hero_section vh-100">
          <div class="hero_content">
              <div class="hero_desc text-center text-md-end">Designs</div>
              <h1 class="hero_title mega_text">projects</h1>
              <div class="hero_desc text-center text-md-start">Coding</div>
          </div>            
      </div>
  </div>
</template>

<script>
export default {
  data() {
      return {
      }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/portfolio/Content/Project.vue